export function makeInputClass() {
    const base = "px--15 py--10 text--text w--100 round border border--bg"
    return {
        underline: `${ base } border-b border--border`,
        fill     : `${ base } bg--body`
    }
}
